/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Filter_MovingInputs */

const vi_fleet_filter_moving = /** @type {(inputs: Fleet_Filter_MovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang di chuyển`)
};

/**

* @param {Fleet_Filter_MovingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_filter_moving = /** @type {((inputs?: Fleet_Filter_MovingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Filter_MovingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_filter_moving(inputs)
});